<template>
    <div class="row">
        <template v-if="entradas.some(entrada => entrada.unidades > 0)">
            <div class="col-12 text-center">
                <h3>TUS ENTRADAS</h3>
            </div>
            <div class="col-12">
                <template v-for="(entrada, index) in entradas">
                    <p class="bg-secondary mb-2 p-2" :key="index" v-if="entrada.unidades > 0">
                        {{ ++index }}. {{ entrada.descripcion }} x{{ entrada.unidades }}
                    </p>
                </template>
            </div>
        </template>
        <template v-if="siguiente != null">
            <div class="col-12" v-if="siguiente">
                <Button class="btn-block" @click.prevent="continuar">CONTINUAR COMPRA</Button>
            </div>
            <div class="col-12" v-else>
                <div class="alert alert-danger" role="alert">
                    El número máximo de entradas permitidas por pedido son 25
                </div>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    props: ['entradas', 'siguiente'],
    data() {
        return {
        }
    },
    methods: {
        continuar() {
            this.$emit('continuar');
        }
    },
}
</script>

<style>

</style>
